
export const arrayConcatUnique = <T extends number | string>(array0: Array<T>, array1: Array<T>): Array<T> => {
    return Array.from(new Set([...array0, ...array1]));
};



// WEBPACK FOOTER //
// ./src/core/util/array-concat-unique.ts